const options = {
  5: "bg-emerald-700/5",
  10: "bg-emerald-700/10",
  25: "bg-emerald-700/25",
  50: "bg-emerald-700/50",
  75: "bg-emerald-700/75",
  90: "bg-emerald-700/90",
  100: "bg-emerald-700",
};

const from = {
  5: "from-emerald-700/5",
  10: "from-emerald-700/10",
  25: "from-emerald-700/25",
  50: "from-emerald-700/50",
  75: "from-emerald-700/75",
  90: "from-emerald-700/90",
  100: "from-emerald-700",
};

export default function getBackgroundEmerald700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
